/* eslint-disable no-console */
import { appFirebase, key } from "./config";
import {
  getMessaging,
  onMessage as onMessageFirebase,
  getToken,
  isSupported,
  NotificationPayload,
  MessagePayload,
} from "firebase/messaging";
import { favicon } from "@config/images";

export const getFCMToken = () => {
  const token = localStorage.getItem("fcm_token");
  return token;
};

/**
 * Request notification permission from user.
 * This should ONLY be called in response to a user gesture (e.g., button click).
 * @returns Promise<boolean> - true if permission granted, false otherwise
 */
export const requestNotificationPermission = async (): Promise<boolean> => {
  try {
    if (!(await isSupported())) {
      return false;
    }

    // Request permission from user
    const permission = await Notification.requestPermission();

    if (permission === "granted") {
      const messaging = getMessaging(appFirebase);
      const currentToken = await getToken(messaging, { vapidKey: key });

      if (currentToken) {
        localStorage.setItem("fcm_token", currentToken);
        return true;
      } else {
        console.log("NOTIFICATION, No registration token available.");
        return false;
      }
    }

    return false;
  } catch (error) {
    console.error("Error requesting notification permission:", error);
    return false;
  }
};

export const onMessage = async () => {
  if (!(await isSupported())) {
    return null;
  }

  const messaging = getMessaging();
  onMessageFirebase(messaging, (payload) => {
    recieveNotif(payload);
  });
};

export const recieveNotif = (payload: MessagePayload) => {
  const data: NotificationPayload = payload.notification ?? {};

  const body = {
    ...data,
    icon: favicon,
  };

  new Notification(data.title ?? "", body);
};

export const init = async () => {
  try {
    if (!(await isSupported())) {
      return null;
    }

    if (getFCMToken() !== null) {
      return false;
    }

    // Check if notification permission is already granted
    // Only get token if permission was previously granted by user
    if (typeof Notification !== "undefined" && Notification.permission === "granted") {
      const messaging = getMessaging(appFirebase);
      getToken(messaging, { vapidKey: key })
        .then((currentToken) => {
          if (currentToken) {
            // Send the token to server and update the UI if necessary
            // save the token in database
            localStorage.setItem("fcm_token", currentToken);
          } else {
            console.log(
              "NOTIFICATION, No registration token available.",
            );
          }
        })
        .catch((err) => {
          console.log("NOTIFICATION error occurred while retrieving token.");
          console.log(err);
        });
    }
  } catch (error) {
    console.error(error);
  }
};

export default {
  onMessage,
  recieveNotif,
  init,
  getFCMToken,
  requestNotificationPermission,
};
